// Enable grab-and-drag scrolling for carousels
document.addEventListener('DOMContentLoaded', () => {
  // Find all scroll-carousel elements
  const carousels = document.querySelectorAll('scroll-carousel');
  
  carousels.forEach(carousel => {
    // Variables for grab-and-drag functionality
    let isDown = false;
    let startX;
    let scrollLeft;
    
    // Add cursor styles
    carousel.style.cursor = 'grab';
    
    // Mouse events for desktop grab-and-drag
    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      carousel.style.cursor = 'grabbing';
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      e.preventDefault(); // Prevent text selection during drag
    });
    
    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    
    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    
    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll speed multiplier
      carousel.scrollLeft = scrollLeft - walk;
      
      // Dispatch a scroll event to update the carousel state
      carousel.dispatchEvent(new Event('scroll'));
    });

    // Touch events for mobile swipe gestures
    let touchStartX = 0;
    let touchEndX = 0;
    
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].screenX;
      carousel.style.cursor = 'grabbing';
    }, { passive: true });
    
    carousel.addEventListener('touchmove', (event) => {
      carousel.style.cursor = 'grabbing';
    }, { passive: true });
    
    carousel.addEventListener('touchend', (event) => {
      touchEndX = event.changedTouches[0].screenX;
      carousel.style.cursor = 'grab';
      
      const distance = touchStartX - touchEndX;
      
      // If the swipe was significant, scroll to the next/previous item
      if (Math.abs(distance) > 50) {
        const direction = distance > 0 ? 1 : -1;
        // Find the item width to scroll by - works with both product cards and collection cards
        const itemWidth = carousel.querySelector('product-card')?.offsetWidth || 
                          carousel.querySelector('.collection-card')?.offsetWidth ||
                          carousel.offsetWidth / 3;
        
        carousel.scrollBy({
          left: itemWidth * direction,
          behavior: 'smooth'
        });
      }
    }, { passive: true });
  });
}); 